/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Default_SetInputs */

const cs_templates_default_set = /** @type {(inputs: Templates_Default_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí šablona aktualizována`)
};

const en_templates_default_set = /** @type {(inputs: Templates_Default_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default template updated`)
};

/**
* | output |
* | --- |
* | "Default template updated" |
*
* @param {Templates_Default_SetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_default_set = /** @type {((inputs?: Templates_Default_SetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Default_SetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_default_set(inputs)
	return cs_templates_default_set(inputs)
});